import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { DELETE_FIELD_REGISTRY, DELETE_FIELD_REGISTRY_SUCCESS, DELETE_FIELD_REGISTRY_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* deleteFieldRegistry({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    // Soft delete — the field is only marked `deleted_at`, never removed, so templates
    // that already reference it keep resolving.
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/field-registry/${payload?.fieldId}/soft-delete`,
      method: 'DELETE',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      cogoToast.success(response?.data?.message || 'Field deleted successfully.');
      yield put({
        type: DELETE_FIELD_REGISTRY_SUCCESS,
        payload: { ...(response?.data ?? {}), fieldId: payload?.fieldId },
      });
    } else {
      const message = response?.response?.data?.message || 'Failed to delete field.';
      cogoToast.error(message);
      yield put({
        type: DELETE_FIELD_REGISTRY_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error('Failed to delete field.');
    yield put({ type: DELETE_FIELD_REGISTRY_ERROR, payload: error });
  }
}

export function* watchdeleteFieldRegistry() {
  yield takeEvery(DELETE_FIELD_REGISTRY, deleteFieldRegistry);
}

function* deleteFieldRegistrySaga() {
  yield all([fork(watchdeleteFieldRegistry)]);
}

export default deleteFieldRegistrySaga;
